namespace app.model.collections {
  export enum CollectionStatus {
    Unknown = "Unknown",
    New = "New",
    Syncing = "Syncing",
    Paused = "Paused",
    Initializing = "Initializing",
    Processing = "Processing",
    Processed = "Processed"
  }
}

// Expose as browser global so cross-module bare references resolve
(window as any).CollectionStatus = app.model.collections.CollectionStatus;

namespace app.model.collections {

  export interface ICollection extends app.model.monitoring.IMonitorable {
    id: string;
    status: CollectionStatus;
    projectId: string;
    custodian: string;
    name: string;
    description: string;
    ritm: string;
    evidence: string;
    release: string;
    extractAttachmentAndEmbeddedDocumentsFromEmails: boolean;
    extractImagesFromEmails: boolean;
    extractFromContainers: boolean;
    extractDocumentsFromFiles: boolean;
    extractImagesFromFiles: boolean;
    imagePresentationsWithNotes: boolean;
    cancelTranscription: boolean;
    cancelExtractEntities: boolean;
    cancelPdf: boolean;
    cancelOcr: boolean;
    numQueued: number;
    numProcessed: number;
    bytesProcessed: number;
    processingSource: any;
    processingOutput: any;
    processingStart: Date;
    processingEnd: Date;
    pdfQueued: number;
    nlpQueued: number;
    ocrQueued: number;
    audioQueued: number;
    job: app.model.job.CollectionJob;
    piiDetectionMode: PIIDetectionMode;
  }

  export interface ICollectionUpdate extends ICollection {
    numQueued: number;
    numProcessed: number;
    bytesProcessed: number;
    processingSource: string;
    processingOutput: number;
    pdfQueued: number;
    ocrQueued: number;
    audioQueued: number;
  }
}
